export const clearQsFromUrl = (url: string): string => {
	const qsStartIndex = url.indexOf('?');
	return qsStartIndex > -1 ? url.substring(0, url.indexOf('?')) : url;
};
